import React from 'react';
import _ComplaintDetailContent from './_ComplaintDetailContent.scss';

class ComplaintDetailContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      complaints: [
        {
          userName: 'Nguyễn Tri Giảng',
          userType: 'Cá nhân',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras feugiat augue at sapien dignissim porta. Suspendisse pellentesque lacinia sapien feugiat scelerisque. Duis nec dolor at tellus pulvinar commodo non et nibh.',
          created: '9:24  10/09/2017'
        },
        {
          userName: 'SangTX',
          userType: 'Công ty A',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras feugiat augue at sapien dignissim porta. Suspendisse pellentesque lacinia sapien feugiat scelerisque. Duis nec dolor at tellus pulvinar commodo non et nibh. Aliquam bibendum suscipit malesuada. Pellentesque eget lobortis eros, non dapibus magna. Duis turpis quam, dignissim a pretium ac, varius nec justo. Aliquam malesuada pulvinar magna, nec sagittis ipsum dapibus non. Maecenas suscipit maximus vehicula. Maecenas quis cursus odio, vel pellentesque lectus. Donec nec iaculis elit. Phasellus auctor ut libero et vestibulum. Praesent purus magna, tincidunt vitae tempor et, consequat ut sapien. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.',
          created: '9:24  10/09/2017'
        }
      ]
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="complaint-wrap">
            {
              this.state.complaints.map((complaint, i) => {
                return (
                  <div className="box-wrap complaint-info-wrap">
                    <div className="content-justify">
                      <h2 className="user-name">{complaint.userName}</h2>
                      <div className="created-time">{complaint.created}</div>
                    </div>
                    <p className="user-type">{complaint.userType}</p>
                    <hr className="complaint-line"/>
                    <p className="complaint-content">{complaint.content}</p>
                  </div>
                )
              })
            }
            <div className="box-wrap feedback-wrap">
              <form>
                <textarea className="feedback-input" name="feedback" rows="4" placeholder="Nhập phản hồi..."/>
              </form>
              <div className="feedback-button">
                <button type="submit" className="update-btn">Phản hồi</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ComplaintDetailContent;



// WEBPACK FOOTER //
// ./components/users/sub-view/complaint-detail-content/ComplaintDetailContent.jsx